module.exports = __webpack_public_path__ + "static/media/Load Request.ee57e805.svg";